<template>
    <div class="hero" v-if="hero" @click="playHeroHere">
        <div class="hero-bg">
            <img :src="hero.backdrop_path" />
        </div>
        <transition name="fade">
            <div class="hero-trailer" v-if="showTrailer">
                <EmbedTrailer :embedKey="trailerURL" :delay="true"/>
            </div>
        </transition>

        <transition name="fade">
            <portal to="details-overlay">
                <div class="expanded-details-modal" v-if="showDetails">
                    <div class="backdrop" @click.stop="toggleDetails"> </div>
                    <div class="details-wrapper">
                        <OnDemandDetails
                            :contentType="hero.type"
                            :contentId="hero.id"
                            :embeded="true"
                            :detailsOnly="false"
                        />
                    </div>
                </div>
            </portal>
        </transition>


        <div class="hero-overlay"></div>
        <div class="hero-content">
            <span class="hero-type">{{ hero.type === 'tv' ? 'Series' : 'Film' }}</span>
            <img :src="logo" v-if="logo"/>
            <h1 v-else>{{ hero.title || hero.name }}</h1>
            <p class="hero-meta" v-if="hero.vote_average">
                <span class="hero-rating">{{ hero.vote_average.toFixed(1) }}</span>
                <span class="hero-year" v-if="hero.release_date">{{ hero.release_date.slice(0, 4) }}</span>
            </p>
            <p class="hero-overview" v-if="hero.overview">{{ hero.overview }}</p>
            <div class="hero-actions">
                <button class="play-btn" v-ripple @click.stop="playHeroHere">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8 5.14v14l11-7-11-7z"/>
                    </svg>
                    Play
                </button>
                <button class="info-btn" v-ripple @click.stop="toggleDetails">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"/>
                        <path d="M12 16v-4M12 8h.01"/>
                    </svg>
                    More Info
                </button>
            </div>
        </div>
    </div>
</template>

<script>
const EmbedTrailer = () => import("@/components/desktop/EmbededTrailer");
const OnDemandDetails = () => import("@/views/Details.vue");
export default {
    name: 'DesktopHero',
    components: {
        OnDemandDetails,
        EmbedTrailer
    },

    data() {
        return {
            hero: null,
            logo: null,
            showDetails: false,
            trailerURL: '',
            showTrailer: false,
        }
    },

    mounted() {
        this.loadHero()
    },

    methods: {
        toggleDetails(){
            this.showDetails = !this.showDetails

        },
        async loadHero() {
            try {
                const res = await window.afetch('/discover', {
                    method: 'POST',
                    body: JSON.stringify({
                        page: 1,
                        query: 'sort_by=popularity.desc&vote_count.gte=2000',
                        type: 'movie',
                    }),
                })
                const data = await res.json()
                if (data.media && data.media.length > 0) {
                    const pick = data.media[Math.floor(Math.random() * Math.min(10, data.media.length))]
                    this.hero = pick
                    this.loadTrailer(pick.id, pick.type)
                }
            } catch (e) {
                // hero stays null
            }
        },

        async loadTrailer(id, type) {
            try {
                const res = await window.afetch(`/trailer?id=${id}&type=${type}`)
                const data = await res.json()
                this.trailerURL = data.url

                if(data.logo){ this.logo = data.logo }
                if(data.url){ this.showTrailer = true }
            } catch (e) {
                // trailer stays null, poster shows
            }finally{
                this.$root.$emit('heroDone')
            }
        },


        goToHero() {
            if (this.hero) {
                this.$router.push(`/${this.hero.type}/${this.hero.id}`)
            }
        },
        playHeroHere(){
                this.$router.push(`/theater?mode=od&type=${this.hero.type}&id=${this.hero.id}`)
        },

        playHero() {
            if (!this.hero) return
            if (!window.did) {
                this.$root.$emit('collectDid', {
                    cb: (d) => {
                        this.doPlay(d)
                    },
                    params: {
                        url: '',
                        title: this.hero.title || this.hero.name,
                        artwork: this.hero.poster_path,
                    }
                })
                return
            }
            this.doPlay(window.did)
        },

        doPlay(did) {
            const data = {
                type: 'od',
                id: this.hero.id,
                did,
                ref: window.location.href,
                url: '',
                name: this.hero.title || this.hero.name,
                logos: [this.hero.poster_path, this.hero.backdrop_path],
                details: {
                    contentType: this.hero.type,
                }
            }
            window.afetch('/start', { method: 'POST', body: JSON.stringify(data) })
        },
    },
}
</script>

<style lang="scss" scoped>
.hero {
    position: relative;
    height: 45vh;
    min-height: 500px;
    padding-bottom: 200px;
    overflow: hidden;
    cursor: pointer;

    .hero-bg {
        position: absolute;
        inset: 0;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .hero-trailer {
        position: absolute;
        inset: 0;
        overflow: hidden;
        top: 0;
        left: 0;
  }

    .hero-overlay {
        position: absolute;
        inset: 0;
        z-index: 2;
        background: linear-gradient(
            to right,
            rgba(14, 14, 14, 1) 0%,
            rgba(14, 14, 14, 0.85) 30%,
            rgba(14, 14, 14, 0.4) 60%,
            rgba(14, 14, 14, 0.1) 100%
        );
    }

    .hero-overlay::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 200px;
        background: linear-gradient(to top, #0e0e0e 0%, transparent 100%);
    }

    .hero-content {
        position: relative;
        z-index: 5;
        padding: 80px 48px 48px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        max-width: 550px;

        .hero-type {
            font-size: 13px;
            font-weight: 600;
            letter-spacing: 1.5px;
            text-transform: uppercase;
            color: rgba(255, 255, 255, 0.6);
            margin-bottom: 12px;
        }

        h1 {
            margin: 0 0 12px 0;
            padding: 0;
            font-size: 48px;
            font-weight: 800;
            line-height: 1.1;
            color: white;
        }

        .hero-meta {
            display: flex;
            align-items: center;
            gap: 12px;
            margin: 0 0 16px 0;

            .hero-rating {
                color: #46d369;
                font-weight: 700;
                font-size: 14px;
            }

            .hero-year {
                color: rgba(255, 255, 255, 0.5);
                font-size: 14px;
            }
        }

        .hero-overview {
            margin: 0 0 24px 0;
            font-size: 14px;
            line-height: 1.5;
            color: rgba(255, 255, 255, 0.7);
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        .hero-actions {
            display: flex;
            gap: 12px;

            .play-btn,
            .info-btn {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 12px 28px;
                border-radius: 8px;
                border: none;
                font-size: 15px;
                font-weight: 600;
                cursor: pointer;
                transition: opacity 0.2s;
            }

            .play-btn {
                background-color: white;
                color: #0e0e0e;

                &:hover {
                    opacity: 0.85;
                }
            }

            .info-btn {
                background-color: rgba(109, 109, 110, 0.7);
                color: white;

                &:hover {
                    background-color: rgba(109, 109, 110, 0.5);
                }
            }
        }
    }
}
</style>
